import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const getCookiePolicyContent = createServerFn({ method: "GET" })
  .inputValidator((input: unknown) => z.object({ locale: z.enum(["sv", "en", "es"]) }).parse(input))
  .handler(async ({ data }) => {
    const { readCookiePolicy } = await import("./cookie-policy.server");
    return readCookiePolicy(data.locale);
  });